"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _models = require("@seedlang/models");
var _root_store = _interopRequireDefault(require("./root_store"));
var _lodash = require("lodash");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var TreeNodeStore = /*#__PURE__*/function (_RootStore) {
  function TreeNodeStore() {
    var _this;
    (0, _classCallCheck2["default"])(this, TreeNodeStore);
    _this = _callSuper(this, TreeNodeStore);
    _this.config = {
      deserialize: true,
      model: _models.TreeNode,
      GET: {
        index: '/tree_nodes',
        show: '/tree_nodes/:treeNodeId'
      },
      PUT: {
        update: '/tree_nodes/:treeNodeId',
        moveToRow: '/tree_nodes/:treeNodeId/move_to_row',
        moveToTreeModule: '/tree_nodes/:treeNodeId/move_to_tree_module',
        createDecks: '/tree_nodes/:treeNodeId/create_decks',
        chooseDeck: '/tree_nodes/:treeNodeId/choose_deck',
        chooseDeckWithOpponent: '/tree_nodes/:treeNodeId/choose_deck/:opponentId',
        createGrammarConcepts: '/tree_nodes/:treeNodeId/create_grammar_concepts',
        toggleAllDecksGrammarDescriptionOverride: 'tree_nodes/:treeNodeId/toggle_all_decks_grammar_description_override'
      },
      POST: {
        create: '/tree_nodes'
      },
      DELETE: {
        destroy: '/tree_nodes/:treeNodeId'
      }
    };
    return _this;
  }
  (0, _inherits2["default"])(TreeNodeStore, _RootStore);
  return (0, _createClass2["default"])(TreeNodeStore, [{
    key: "moveToRow",
    value: function moveToRow(params, callback) {
      this.api(params, callback || this.getShow.bind(this), 'PUT', 'moveToRow');
    }
  }, {
    key: "createDecks",
    value: function createDecks(params, callback) {
      this.api(params, callback || this.getShow.bind(this), 'PUT', 'createDecks');
    }
  }, {
    key: "chooseDeck",
    value: function chooseDeck(params, callback) {
      this.api(params, callback, 'PUT', 'chooseDeck');
    }
  }, {
    key: "moveToTreeModule",
    value: function moveToTreeModule(params, callback) {
      this.api(params, callback || this.getShow.bind(this), 'PUT', 'moveToTreeModule');
    }
  }, {
    key: "createGrammarConcepts",
    value: function createGrammarConcepts(params, callback) {
      this.api(params, callback || this.getShow.bind(this), 'PUT', 'createGrammarConcepts');
    }
  }, {
    key: "toggleAllDecksGrammarDescriptionOverride",
    value: function toggleAllDecksGrammarDescriptionOverride(params, callback) {
      this.api(params, callback || this.getShow.bind(this, params, _lodash.noop), 'PUT', 'toggleAllDecksGrammarDescriptionOverride');
    }
  }]);
}(_root_store["default"]);
var _default = exports["default"] = new TreeNodeStore();